import { render } from "./HelloWorld.vue?vue&type=template&id=249a59d2&scoped=true"
import script from "./HelloWorld.vue?vue&type=script&lang=js"
export * from "./HelloWorld.vue?vue&type=script&lang=js"

import "./HelloWorld.vue?vue&type=style&index=0&id=249a59d2&lang=scss&scoped=true"

import exportComponent from "/home/alex/IdeaProjects/PokemonSpriteEditor2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-249a59d2"]])

export default __exports__